

import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, State, Getter } from "vuex-class"

import vSelect from "vue-select"
// @ts-ignore
import { Team, TimeZone } from "@/types"
import { MultipleRecordInstance } from "@/types/schedule"
import FieldControl from "@/components/Fields/FieldControl.vue"
import { CaseColumn } from "@/types/caseColumns"
import FieldAndValue from "@/components/Controls/FieldAndValue.vue"
import { orderBy, cloneDeep } from "lodash"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"field-control": FieldControl,
		"field-and-value": FieldAndValue
	}
})
export default class MultiCreateControl extends Vue {
	@Getter getCaseName!: string;

	@Getter getTenantTimezones!: TimeZone[]

	@Prop({ default: () => [] })
	value!: MultipleRecordInstance[]

	@Prop({ default: () => null })
	recordsToCreate?: number

	@Prop({ default: () => [] })
	multipleRecordFields?: CaseColumn[]

	@Prop({ default: () => null })
	validationErrors?: string

	@Prop({ type: Boolean, default: false })
	useTimezones!: boolean

	@Prop({ type: String, default: null })
	scheduleMainTimezone!: string | null

	@Prop({ type: Array, default: [] })
	timezones!: TimeZone[]

	@Prop({ type: Boolean, default: false })
	readonly!: boolean

	@setup.State
	teams!: Team[]

	@setup.Action
	loadTeams!: () => Promise<void>

	mounted () {
		if (this.useTimezones) {
			this.value.forEach(instance => instance.startTime = "00:00")
		} else {
			// In case 'hide start times' tenant feature is disabled, as timezones take precedence over start times
			this.value.forEach(instance => instance.timezone = undefined)
		}
	}

	public get multiCreateDetails (): MultipleRecordInstance[] {
		if (!this.recordsToCreate) {
			return []
		}

		// Create times if they don't exist
		if (!this.value) {
			var multipleTimes: MultipleRecordInstance[] = []

			for (let i = 0; i < this.recordsToCreate; i++) {
				let item: MultipleRecordInstance = {
					startTime: null,
					fields: {},
					timezone: this.useTimezones ? this.scheduleMainTimezone ?? undefined : undefined
				}

				multipleTimes.push(item)
			}

			this.value = multipleTimes
			this.valueUpdate(multipleTimes)

			return this.value
		}

		let _value = cloneDeep(this.value)

		if (this.recordsToCreate < _value.length) {
			let itemsToRemove = _value.length - this.recordsToCreate
			// Remove item
			_value.splice(-itemsToRemove)
		} else if (this.recordsToCreate > _value.length) {
			// Add items
			let itemsToAdd = this.recordsToCreate - _value.length

			for (let i = 0; i < itemsToAdd; i++) {
				let item: MultipleRecordInstance = {
					startTime: null,
					fields: {},
					timezone: this.useTimezones ? this.scheduleMainTimezone ?? undefined : undefined
				}
				_value.push(item)
			}
		}

		this.value = _value
		this.valueUpdate(_value)

		return this.value
	}

	public removeTime (index: number) {
		this.multiCreateDetails!.splice(index, 1)

		this.AmountUpdate(this.recordsToCreate! - 1)
	}

	// Sort By start time
	public TimeChanged () {
		this.value = orderBy(this.value, ["startTime"], ["asc"])

		this.valueUpdate(this.value)
	}

	public TimezoneChanged () {
		this.valueUpdate(this.value)
	}

	public valueUpdate (newValue: MultipleRecordInstance[]): void {
		this.$emit("input", newValue)
	}

	public AmountUpdate (amount: number): void {
		this.$emit("amountChanged", amount)
	}
}

